import { render, staticRenderFns } from "./ProjectThumbnail.vue?vue&type=template&id=6ddd84f2&scoped=true&lang=html"
import script from "./ProjectThumbnail.vue?vue&type=script&lang=js"
export * from "./ProjectThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProjectThumbnail.vue?vue&type=style&index=0&id=6ddd84f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd84f2",
  null
  
)

export default component.exports